import { render, staticRenderFns } from "./JobAlterarCoordenadorView.vue?vue&type=template&id=0a210b63&scoped=true"
import script from "./JobAlterarCoordenadorView.vue?vue&type=script&setup=true&lang=js"
export * from "./JobAlterarCoordenadorView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobAlterarCoordenadorView.vue?vue&type=style&index=0&id=0a210b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a210b63",
  null
  
)

export default component.exports